export const AriaOwns = 'aria-owns'
export const AriaLabelledBy = 'aria-labelledby'
export const AriaDescribedBy = 'aria-describedby'
export const AriaDescription = 'aria-description'
export const AriaLevel = 'aria-level'
export const AriaExpanded = 'aria-expanded'
export const AriaMultiSelectable = 'aria-multiselectable'
export const AriaActiveDescendant = 'aria-activedescendant'
export const AriaBusy = 'aria-busy'
export const AriaSelected = 'aria-selected'
export const AriaControls = 'aria-controls'
export const AriaHidden = 'aria-hidden'
